import { Img } from 'react-image';

import React from 'react';
class Media extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      base: tmp_path.temp_uri,
      sp: props.sp,
      src: props.src,
      alt: props.alt,
      class: props.class ? props.class : '',
      class_picture: props.pClass ? props.pClass+' '+props.class+'__wrap' : props.class+'__wrap',
      state: props.state ? props.state : '',
      breakpoint: props.breakpoint ? props.breakpoint : '1080px',
    }
  }

  render() {
    let sp;
    if(this.state.sp) {
      sp = (
        <source
          media={`(max-width: ${this.state.breakpoint})`}
          srcSet={this.state.base + '/dist/assets/images/' + this.state.src + '-sp' + '.webp' }
        ></source>
      )
    }
    return(
      <picture 
        className={this.state.class_picture}
        data-state={this.state.state}
      >
        { sp }
        <Img
          className={this.state.class}
          src={[ this.state.base + '/dist/assets/images/' + this.state.src + '.webp', ]}
          alt={this.state.alt} />
      </picture>
    )
  }
}

export default Media;
